/**
 * Live Session tab — classroom list, join code display, exception panel.
 *
 * Placeholder content. The real live-session view (per-student status
 * tiles, exception alerts, "unstick" actions) lands later.
 */
export function LiveTab(): JSX.Element {
  return (
    <div className="grid gap-6 lg:grid-cols-[2fr_1fr]">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Live session</h1>
        <p className="mt-1 text-sm text-slate-600">
          Classrooms you're running right now. Project the join code on the room TV.
        </p>

        <div className="mt-6 rounded-2xl border-2 border-dashed border-amber-200 bg-white p-10 text-center">
          <p className="text-sm text-slate-500">
            No classrooms yet. Once you have one, the join code + roster show up here.
          </p>
        </div>
      </div>

      <aside className="rounded-2xl border border-amber-100 bg-white p-6">
        <h2 className="text-base font-semibold text-slate-900">Exceptions</h2>
        <p className="mt-2 text-sm text-slate-500">
          Stuck students and idle hands will surface here during the period.
        </p>
        <div className="mt-4 rounded-xl bg-amber-50 p-4 text-sm text-amber-900">
          Nothing flagged.
        </div>
      </aside>
    </div>
  );
}
